const routers = [
  {
    path: "/",
    redirect: "/phonePage",
    name: "HelloWorld",
    component: () => import("@/views/HelloWorld.vue")
  },
  {
    path: "/phonePage",
    name: "phonePage",
    component: () => import("@/views/pcpage/phonePage.vue")
  },
  {
    path: "/Healthkit",
    name: "Healthkit",
    component: () => import("@/views/pcpage/Healthkit.vue")
  },
  {
    path: "/EnterpriseRegistration",
    name: "EnterpriseRegistration",
    component: () => import("@/views/pcpage/EnterpriseRegistration.vue")
  },
  {
    path: "/art",
    name: "art",
    component: () => import("@/views/pcpage/artPage.vue")
  },
  {
    path: "/ill",
    name: "ill",
    component: () => import("@/views/pcpage/illPage.vue")
  },
  {
    path: "/yiMei",
    name: "yiMei",
    component: () => import("@/views/pcpage/yiMei.vue")
  },
  {
    path: "/voice",
    name: "voice",
    component: () => import("@/views/pcpage/voice.vue")
  },
  {
    path: "/live",
    name: "live",
    component: () => import("@/views/pcpage/livePage.vue")
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("@/views/pcpage/aboutUs.vue")
  },
  {
    path: "/VotingList",
    name: "VotingList",
    component: () => import("@/views/pcpage/VotingList.vue")
  },
  {
    path: "/privacypolicy",
    name: "Privacypolicy",
    component: () => import("@/views/privacypolicy.vue")
  },
  {
    path: "/HealthManagementPlatform",
    nmae: "HealthManagementPlatform",
    component: () => import("@/views/pcpage/HealthManagementPlatform")
  },
  {
    path: "/donation",
    name: "donation",
    component: () => import("@/views/pcpage/donationPage.vue")
  }
];
export default routers;



// WEBPACK FOOTER //
// ./src/router/pcRouter.js